import { render, staticRenderFns } from "./lymphomap-staff-list.html?vue&type=template&id=6515e824&scoped=true&external"
import script from "./lymphomap-staff-list.js?vue&type=script&lang=js&external"
export * from "./lymphomap-staff-list.js?vue&type=script&lang=js&external"
import style0 from "./lymphomap-staff-list.scss?vue&type=style&index=0&id=6515e824&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515e824",
  null
  
)

export default component.exports